import React from 'react';
import { Typography } from '@mui/material';
import SettingsCard from '../components/SettingsCard';

const PreferencesSettings = () => {
  return (
    <SettingsCard title="Preferencias">
      <Typography color="text.secondary">
        Sección en desarrollo
      </Typography>
    </SettingsCard>
  );
};

export default PreferencesSettings;